export const createTimeoutPromise = (timeoutInMs: number): Promise<void> => {
    return new Promise(resolve => setTimeout(resolve, timeoutInMs));
};
